import React, { Component } from 'react';
import style from './index.scss';
import Proptypes from 'prop-types';
import { message, Space, Layout, Upload } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { uploadFileToServer } from '../../../../services/util';
import { TRM_CONSTANTS } from '../../../constants/trmConstants';
const { Content } = Layout;
const { Dragger } = Upload;
/**
 * UploadWidget
 */
class UploadWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFileUploaded: false,
      uploadedData: ''
    };

    /**
     *
     * @type {{name: string, multiple: boolean,
     * progress: {strokeWidth: number, format:
     * (function(*): string), strokeColor: {'100%': string, '0%': string}}, accept: string}}
     */
    this.draggerProps = {
      name: 'file',
      multiple: false,
      accept: '.typology',
      progress: {
        strokeColor: {
          '0%': '#108ee9',
          '100%': '#87d068'
        },
        strokeWidth: 3,
        format: (percent) => `${parseFloat(percent.toFixed(2))}%`
      }
    };
  }

  /**
   * onFileUpload
   * @param event
   */
  onFileUpload = (event) => {
    const uploadedFile = event.file;
    const fileSize = uploadedFile.size / 1024 / 1024; // in MB
    if (fileSize > 2) {
      this.toggleAlert('File size cannot be greater than 2Mb');
      return;
    }
    this.setState(
      () => ({
        loaded: 0,
        onStartUpload: true
      }),
      () => {
        const data = new FormData();
        data.append('file', uploadedFile);
        uploadFileToServer(
          TRM_CONSTANTS.TRM_BASE_URL + '/typologies/upload',
          data,
          event.onProgress
        ).then((res) => {
          const { data = {}, status } = res;
          if (status === 200 || status === 202) {
            event.onSuccess(res.data);
            this.setState(
              { isFileUploaded: true, uploadedData: res.data },
              () => {
                this.props.isFileUploadedFunc(
                  this.state.isFileUploaded,
                  this.state.uploadedData
                );
              }
            );
            data.forEach((element) => {
              if (element.state === 'NoPermission') {
                message.error(
                  `${event.file.name}  file upload failed - No permission.`
                );
              } else
                message.success(
                  `${event.file.name} file uploaded successfully.`
                );
            });
          } else {
            event.onError(res.data);
            message.error(`${event.file.name} file upload failed.`);
          }
        });
      }
    );
  };

  render() {
    return (
      <Content className={style.content}>
        <Space size={5} direction="vertical" style={{ width: '100%' }}>
          <Content className={style.container}>
            <Dragger
              customRequest={this.onFileUpload}
              style={{ height: 170 }}
              {...this.draggerProps}>
              <p className={style.upload_icon}>
                <PlusOutlined />
              </p>
              <p className={style.upload_icon_text}>Upload TMI</p>
              <p className={style.upload_icon_hint}>
                Click here or Drag File here
              </p>
            </Dragger>
            ,
            <div className={style.upload_icon_hint}>
              Upload typology meta information file that you have downloaded
              from typology creation tool. The size of the file should not
              exceed 2 MB.
            </div>
          </Content>
        </Space>
      </Content>
    );
  }
}

/**
 * propTypes
 * @type {{isFileUploadedFunc: ((function(*, *, *, *, *, *): undefined)|*)}}
 */
UploadWidget.propTypes = {
  isFileUploadedFunc: Proptypes.func
};

export default UploadWidget;
